var _circle, _path, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 28,
    fill: "#FFEBC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 58.2687L3.57 65.8987C2.91667 66.5521 2.15833 66.7 1.295 66.3425C0.431667 65.9855 0 65.3476 0 64.4287V17.6687C0 16.5487 0.42 15.5687 1.26 14.7287C2.1 13.8887 3.08 13.4688 4.2 13.4688H51.8C52.92 13.4688 53.9 13.8887 54.74 14.7287C55.58 15.5687 56 16.5487 56 17.6687V54.0687C56 55.1887 55.58 56.1687 54.74 57.0087C53.9 57.8487 52.92 58.2687 51.8 58.2687H11.2ZM9.38 54.0687H51.8V17.6687H4.2V59.6687L9.38 54.0687Z",
    fill: "#395966"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 36,
    r: 3,
    fill: "#FCBE1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 3,
    fill: "#FCBE1F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 36,
    r: 3,
    fill: "#FCBE1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.42d4c1e31511f68eccdb535ad3d22c7c.svg";
export { ForwardRef as ReactComponent };